import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import styled from 'styled-components';
import BookElement from 'app/api/bookElement';

import { Box, Text, Carousel as GrommetCarousel } from 'grommet';

import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
const scrollIntoViewOptions = { behavior: 'instant', block: 'start' };

const Container = styled.div`
  max-width: 600px;
  max-height: 600px;
  margin: 32px auto;
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
`;

class Carousel extends React.Component {
  render() {
    const { AppState, path, content } = this.props;
    return (
      <Container>
        <ScrollIntoViewIfNeeded
          options={scrollIntoViewOptions}
          active={_.isEqual(path, AppState.selectedSectionItem)}
        >
          <Box align="center">
            <GrommetCarousel aria-label="carousel" play={5000}>
              {content.panels.map((panel, index) => {
                const source = panel.source.startsWith('http')
                  ? panel.source
                  : require('../../../content' + panel.source);
                return (
                  <Box key={index}>
                    <Image src={source} alt={panel.caption} />
                    <Text weight="bold" textAlign="center">
                      {panel.caption}
                    </Text>
                  </Box>
                );
              })}
            </GrommetCarousel>
            <Text weight="bold" textAlign="center">
              {BookElement.extractTitleFromPath(path)} — {content.caption}
            </Text>
          </Box>
        </ScrollIntoViewIfNeeded>
      </Container>
    );
  }
}

Carousel.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * source,caption, and prefix
   */
  content: PropTypes.shape({
    caption: PropTypes.string.isRequired,
    prefix: PropTypes.string,
    type: PropTypes.string,
    panels: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
};
Carousel.defaultProps = {
  content: {},
};

const Component = inject('AppState')(observer(Carousel));
Component.displayName = 'Carousel';
export const CarouselComponent = Carousel;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Carousel.js